import { format } from "date-fns";
import { ProyectoColaboradoreDTO } from "./ProyectoColaboradoreDTO";

export interface ColaboradorProdcutoDTO{
    Iddecinvproyectoprtercol: number,
    Iddecinvproyectoprodtermin: number,
    Colaborador: ProyectoColaboradoreDTO
}

export interface ProductoColaboradorDTO{
        iddecinvproyectoprtercol: number,  
        iddecinvproyectoprodtermin: number,
        tipoparticipacion: number, 
        iddecinvproyectocolaboradores: number, 
        iddecinvproyecto: number, 
        tipocolaborador: number, 
        cedula: string, 
        nombre: string, 
        email: string, 
        iddecinvrolinvestigador: number, 
        ultimoCambio: string, 
        institucion: string, 
        idunidad: number, 
        escolabproyecto: number, 
        enescalafon: string, 
        considerarestimulo: string, 
        estimulo: string, 
        fechacheckescalafon: string, 
        titulosubproyecto: string, 
        fechaingresoproyecto: string, 
        fechasalidaproyecto: string,
        porcentajeparticipacion: number 
}

export function getVoidProductoColaboradorDTO():ProductoColaboradorDTO{
    return{
        iddecinvproyectoprtercol: 0,  
        iddecinvproyectoprodtermin: 0,
        tipoparticipacion: 0, 
        iddecinvproyectocolaboradores: 0, 
        iddecinvproyecto: 0, 
        tipocolaborador: 0, 
        cedula: '', 
        nombre: '', 
        email: '', 
        iddecinvrolinvestigador: 0, 
        ultimoCambio: '', 
        institucion: '', 
        idunidad: 0, 
        escolabproyecto: 0, 
        enescalafon: '', 
        considerarestimulo: '', 
        estimulo: '', 
        fechacheckescalafon: '', 
        titulosubproyecto: '', 
        fechaingresoproyecto: '', 
        fechasalidaproyecto: '',
        porcentajeparticipacion: 0 
    }
}

export function setProductoColaborador(data: any): ProductoColaboradorDTO{    
    const fechaHoy = new Date(); // Obtiene la fecha y hora actual
    const fechaNula = new Date(1, 0, 1);
    return{
        iddecinvproyectoprtercol: data.iddecinvproyectoprtercol?? 0,  
        iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin?? 0,
        tipoparticipacion: data.tipoparticipacion??0,
        iddecinvproyectocolaboradores: data.iddecinvproyectocolaboradores?? 0,
        iddecinvproyecto: data.iddecinvproyecto?? 0,
        tipocolaborador: data.tipocolaborador?? 0, 
        cedula: data.cedula?? "",  
        nombre: data.nombre?? "",  
        email: data.email?? "", 
        iddecinvrolinvestigador: data.iddecinvrolinvestigador?? 0, 
        ultimoCambio: data.ultimoCambio?? "", 
        institucion: data.institucion?? "", 
        idunidad: data.idunidad?? 0, 
        escolabproyecto: data.escolabproyecto?? 0, 
        enescalafon: data.enescalafon?? "", 
        considerarestimulo: data.considerarestimulo?? "", 
        estimulo: data.estimulo?? "", 
        fechacheckescalafon: data.fechacheckescalafon?? format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"), 
        fechaingresoproyecto: data.fechaingresoproyecto?? format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"), 
        fechasalidaproyecto: data.fechasalidaproyecto?? format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
        porcentajeparticipacion: data.porcentajeparticipacion?? 0,
        titulosubproyecto: data.titulosubproyecto?? "",
    }
}

export function setListProductoColaborador(data: Array<any>): Array<ProductoColaboradorDTO>{
    let listProductoColaborador: Array<ProductoColaboradorDTO> = [];
    data.forEach((item) => {
        const productoColaboradorDTO: ProductoColaboradorDTO = setProductoColaborador(item)
        listProductoColaborador.push(productoColaboradorDTO);
    });
    return listProductoColaborador;
}

export function setProductoColConferencia(data: any): ProductoColaboradorDTO{    
    return{
        iddecinvproyectoprtercol: 0,  
        iddecinvproyectoprodtermin: 0,
        tipoparticipacion: data.tipoparticipacion??0,
        iddecinvproyectocolaboradores: 0,
        iddecinvproyecto: data.iddecinvproyecto?? 0,
        tipocolaborador: data.tipocolaborador?? 0, 
        cedula: data.cedula?? "",  
        nombre: data.nombre?? "",  
        email: data.email?? "", 
        iddecinvrolinvestigador: data.iddecinvrolinvestigador?? 0, 
        ultimoCambio: data.ultimoCambio?? "", 
        institucion: data.institucion?? "", 
        idunidad: data.idunidad?? 0, 
        escolabproyecto: data.escolabproyecto?? 0, 
        enescalafon: data.enescalafon?? "", 
        considerarestimulo: data.considerarestimulo?? "", 
        estimulo: data.estimulo?? "", 
        fechacheckescalafon: data.fechacheckescalafon=== null || data.fechacheckescalafon === "" ? "1901-01-01T00:00:00.000-05:14" : data.fechacheckescalafon, 
        titulosubproyecto: data.titulosubproyecto?? "",
        fechaingresoproyecto: data.fechaingresoproyecto?? "", 
        fechasalidaproyecto: data.fechasalidaproyecto === null || data.fechasalidaproyecto === "" ? "1901-01-01T00:00:00.000-05:14" : data.fechasalidaproyecto,
        porcentajeparticipacion: data.porcentajeparticipacion?? 0,
    }
}

export function setListProductoColConferencia(data: Array<any>): Array<ProductoColaboradorDTO>{
    let listProductoColaborador: Array<ProductoColaboradorDTO> = [];
    data.forEach((item) => {
        const productoColaboradorDTO: ProductoColaboradorDTO = setProductoColConferencia(item)
        listProductoColaborador.push(productoColaboradorDTO);
    });
    return listProductoColaborador;
}